<template>
  <div>
    <h3 size="medium">成本信息</h3>
    <!--        费率设置-->
    <el-form label-width="100px" ref="rateForm" :model="rateForm" class="rateForm">
      <el-card shadow="never" v-if="!readOnly">
        <el-form-item label="费率模板选择">
          <el-select v-model="selectedTemplate" @change="rateTemplateSelectChange">
            <el-option label="自定义" :value="-1" :key="-1"></el-option>
            <el-option :label="template.name" :value="template.id" v-for="template in rateTemplateList" :key="template.id"></el-option>
          </el-select>
          <div v-if="isEdit">提示:费率信息无变更，无需选择</div>
          <a href="static/费率模板操作指引.docx" download v-if="!isEdit && !readOnly">
            <span class="file-download-button">费率模板操作指引</span>
          </a>
        </el-form-item>
      </el-card>

      <div v-loading="saleLoading" >
        <el-card shadow="never">
          <p class="title">刷卡费率</p>
          <el-table :data="cardTable" border size="small" align="center" style="width:900px;" :span-method="editTemplateTableSpanMethod">
            <el-table-column prop="type" label="类型" align="center"></el-table-column>
            <el-table-column prop="d1" label="D+1费率" width="180" align="center">
              <template slot-scope="scope">
                <el-input v-model="rateForm[scope.row.d1]" @blur="onRateBlur(scope.row.d1)" :disabled="readOnly">
                  <span slot="suffix">%</span>
                </el-input>
              </template>
            </el-table-column>
            <el-table-column prop="d1Max" label="D+1封顶手续费" width="180" align="center">
              <template slot-scope="scope">
                <el-input v-model="rateForm[scope.row.d1Max]" @blur="onRateBlur(scope.row.d1Max)" v-if="scope.row.d1Max !== '--'" :disabled="readOnly"></el-input>
                <span v-else>——</span>
              </template>
            </el-table-column>
            <el-table-column prop="d0" label="D+0费率" width="180" align="center">
              <template slot-scope="scope">
                <el-input v-model="rateForm[scope.row.d0]" @blur="onRateBlur(scope.row.d0)" v-if="scope.row.d0 !== '--'" :disabled="readOnly">
                  <span slot="suffix">%</span>
                </el-input>
                <span v-else>——</span>
              </template>
            </el-table-column>
            <el-table-column prop="d0Fixed" label="D+0单笔手续费" width="180" align="center">
              <template slot-scope="scope">
                <el-input v-model="rateForm[scope.row.d0Fixed]" @blur="onRateBlur(scope.row.d0Fixed)" v-if="scope.row.d0Fixed !== '--'" :disabled="readOnly"></el-input>
                <span v-else>——</span>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
        <el-card shadow="never">
          <p class="title">扫码费率</p>
          <el-table :data="scanWechatTable" border size="small" align="center" style="width:1080px">
            <el-table-column prop="type" label="微信费率" align="center">
              <el-table-column prop="extraType" label="费用类型" align="center"></el-table-column>
              <el-table-column prop="d1" label="D+1费率" align="center">
                <template slot-scope="scope">
                  <el-input v-model="rateForm[scope.row.d1]" @blur="onRateBlur(scope.row.d1)" v-if="scope.row.d1 !== '--'" :disabled="readOnly">
                    <span slot="suffix">%</span>
                  </el-input>
                  <span v-else>——</span>
                </template>
              </el-table-column>
              <el-table-column v-if='isShowD0' prop="d0" label="D+0费率" align="center">
                <template slot-scope="scope">
                  <el-input-number :controls="false" :max='0.6' v-model="rateForm[scope.row.d0]" @blur="onRateBlur(scope.row.d0)" v-if="scope.row.d0 !== '--'" :disabled="readOnly">
                    <span slot="suffix">%</span>
                  </el-input-number>
                  <span v-else>——</span>
                </template>
              </el-table-column>
            </el-table-column>
          </el-table>
          <el-collapse v-model="showWechat" style="width:1080px;margin-bottom: 20px;border-bottom: none">
            <el-collapse-item title="多通道费率" name="1">
              <el-table :data="scanWechatMulti" border size="small" align="center" style="width:720px;">
                <el-table-column prop="extraTypeL" label="费用类型" align="center"> </el-table-column>
                <el-table-column prop="d1L" label="D+1费率" align="center">
                  <template slot-scope="scope">
                    <div @click="clickExtraRate(scope.row.typeLetterL, scope.row.d1L)" v-if="scope.row.d1L !== '--'">
                      <el-input
                        v-model="rateForm.extraFeeRate[scope.row.typeLetterL][scope.row.d1L]"
                        @blur="onRateBlur(scope.row.typeLetterL === 'wechat'
                          ? 'weixinT1Rate'
                          : 'alipayT1Rate', scope.row.typeLetterL + '.' + scope.row.d1L)"
                        :disabled="readOnly || defaultRate.extraFeeRate[scope.row.typeLetterL][scope.row.d1L] === ''">
                        <span slot="suffix">%</span>
                      </el-input>
                    </div>
                    <span v-else>——</span>
                  </template>
                </el-table-column>
                <el-table-column prop="extraTypeR" label="费用类型" align="center"></el-table-column>
                <el-table-column prop="d1R" label="D+1费率" align="center">
                  <template slot-scope="scope">
                    <div @click="clickExtraRate(scope.row.typeLetterR, scope.row.d1R)" v-if="scope.row.d1R !== '--'">
                      <el-input
                        v-model="rateForm.extraFeeRate[scope.row.typeLetterR][scope.row.d1R]"
                        @blur="onRateBlur(scope.row.typeLetterR === 'wechat'
                          ? 'weixinT1Rate'
                          : 'alipayT1Rate', scope.row.typeLetterR + '.' + scope.row.d1R)"
                        :disabled="readOnly || defaultRate.extraFeeRate[scope.row.typeLetterR][scope.row.d1R] === ''">
                        <span slot="suffix">%</span>
                      </el-input>
                    </div>
                    <span v-else>——</span>
                  </template>
                </el-table-column>
              </el-table>
            </el-collapse-item>
          </el-collapse>
          <el-collapse v-model="showRihua" style="width:360px;margin-bottom: 20px;border-bottom: none">
            <el-collapse-item title="服饰日化费率" name="1">
              <el-row class="row">
                <el-col class="item">费用类型</el-col>
                <el-col class="item">D+1费率</el-col>
              </el-row>
              <el-row class="row">
                <el-col class="item">服饰日化-借记卡</el-col>
                <el-col class="item">
                  <el-input v-model="rateForm.wxCategoryDebitCommissionD1">
                    <template slot="append">%</template>
                  </el-input>
                </el-col>
              </el-row>
              <el-row  class="row">
                <el-col class="item">服饰日化-贷记卡</el-col>
                <el-col class="item">
                  <el-input v-model="rateForm.wxCategoryCreditCommissionD1">
                    <template slot="append">%</template>
                  </el-input>
                </el-col>
              </el-row>
            </el-collapse-item>
          </el-collapse>
        </el-card>
        <el-card shadow="never">
          <el-table :data="scanAlipayTable" border size="small" align="center" style="width:1080px;">
            <el-table-column prop="type" label="支付宝费率" align="center">
              <el-table-column prop="extraType" label="费用类型" align="center"> </el-table-column>
              <el-table-column prop="d1" label="D+1费率" align="center">
                <template slot-scope="scope">
                  <el-input v-model="rateForm[scope.row.d1]" @blur="onRateBlur(scope.row.d1)" v-if="scope.row.d1 !== '--'" :disabled="readOnly">
                    <span slot="suffix">%</span>
                  </el-input>
                  <span v-else>——</span>
                </template>
              </el-table-column>
              <el-table-column v-if='isShowD0' prop="d0" label="D+0费率" align="center">
                <template slot-scope="scope">
                  <el-input-number :controls="false" :max='0.6'
                    v-model="rateForm[scope.row.d0]"
                    @blur="onRateBlur(scope.row.d0)"
                    v-if="scope.row.d1 !== '--'"
                    :disabled="readOnly">
                    <span slot="suffix">%</span>
                  </el-input-number>
                  <span v-else>——</span>
                </template>
              </el-table-column>
            </el-table-column>
          </el-table>
          <el-collapse v-model="showAlipay" style="width:1080px;margin-bottom: 20px;border-bottom: none">
            <el-collapse-item title="多通道费率" name="1">
              <el-table :data="scanAlipayMulti" border size="small" align="center" style="width:720px;">
                <el-table-column prop="extraTypeL" label="费用类型" align="center"></el-table-column>
                <el-table-column prop="d1L" label="D+1费率" align="center">
                  <template slot-scope="scope">
                    <div @click="clickExtraRate(scope.row.typeLetterL, scope.row.d1L)" v-if="scope.row.d1L !== '--'">
                      <el-input v-model="rateForm.extraFeeRate[scope.row.typeLetterL][scope.row.d1L]"
                        @blur="onRateBlur(scope.row.typeLetterL === 'wechat'
                          ? 'weixinT1Rate'
                          : 'alipayT1Rate', scope.row.typeLetterL + '.' + scope.row.d1L)"
                        :disabled="readOnly || defaultRate.extraFeeRate[scope.row.typeLetterL][scope.row.d1L] === ''">
                        <span slot="suffix">%</span>
                      </el-input>
                    </div>
                    <span v-else>——</span>
                  </template>
                </el-table-column>
                <el-table-column prop="extraTypeR" label="费用类型" align="center"></el-table-column>
                <el-table-column prop="d1R" label="D+1费率" align="center">
                  <template slot-scope="scope">
                    <div @click="clickExtraRate(scope.row.typeLetterR, scope.row.d1R)" v-if="scope.row.d1R !== '--'">
                      <el-input v-model="rateForm.extraFeeRate[scope.row.typeLetterR][scope.row.d1R]"
                        @blur="onRateBlur(scope.row.typeLetterR === 'wechat'
                          ? 'weixinT1Rate'
                          : 'alipayT1Rate', scope.row.typeLetterR + '.' + scope.row.d1R)"
                        :disabled="readOnly || defaultRate.extraFeeRate[scope.row.typeLetterR][scope.row.d1R] === ''">
                        <span slot="suffix">%</span>
                      </el-input>
                    </div>
                    <span v-else>——</span>
                  </template>
                </el-table-column>
              </el-table>
            </el-collapse-item>
          </el-collapse>
        </el-card>
        <el-card shadow="never">
          <p class="title">银联二维码费率</p>
          <el-table :data="unionpayTable" border size="small" align="center" style="width:1080px;">
            <el-table-column prop="type" label="类型" align="center"></el-table-column>
            <el-table-column prop="d1" label="D+1费率>1000元" width="180" align="center">
              <template slot-scope="scope">
                <el-input v-model="rateForm[scope.row.d1]" @blur="onRateBlur(scope.row.d1)" v-if="scope.row.d1 !== '--'" :disabled="readOnly">
                  <span slot="suffix">%</span>
                </el-input>
                <span v-else>——</span>
              </template>
            </el-table-column>
            <el-table-column prop="d1Max" label="D+1封顶手续费" width="180" align="center">
              <template slot-scope="scope">
                <el-input v-model="rateForm[scope.row.d1Max]" @blur="onRateBlur(scope.row.d1Max)" v-if="scope.row.d1Max !== '--'" :disabled="readOnly"></el-input>
                <span v-else>——</span>
              </template>
            </el-table-column>
            <el-table-column prop="d1Level2" label="D+1费率≤1000元" width="180" align="center">
              <template slot-scope="scope">
                <el-input v-model="rateForm[scope.row.d1Level2]" @blur="onRateBlur(scope.row.d1Level2)" v-if="scope.row.d1Level2 !== '--'" :disabled="readOnly">
                  <span slot="suffix">%</span>
                </el-input>
                <span v-else>——</span>
              </template>
            </el-table-column>
            <el-table-column prop="d0" v-if='isShowD0' label="D+0费率>1000元" width="180" align="center">
              <template slot-scope="scope">
                <el-input-number :controls="false" :max='0.6'  v-model="rateForm[scope.row.d0]" @blur="onRateBlur(scope.row.d0)" v-if="scope.row.d0 !== '--'" :disabled="readOnly">
                  <span slot="suffix">%</span>
                </el-input-number>
                <span v-else>——</span>
              </template>
            </el-table-column>
            <el-table-column prop="d0Level2" v-if='isShowD0' label="D+0费率≤1000元" width="180" align="center">
              <template slot-scope="scope">
                <el-input-number :controls="false" :max='0.6' v-model="rateForm[scope.row.d0Level2]" @blur="onRateBlur(scope.row.d0Level2)" v-if="scope.row.d0Level2 !== '--'" :disabled="readOnly">
                  <span slot="suffix">%</span>
                </el-input-number>
                <span v-else>——</span>
              </template>
            </el-table-column>
          </el-table>
        </el-card>

        <el-card shadow="never">
          <p class="title">扫码点餐类扫码费率</p>
          <div class="two-table">
            <div class="cutom-table">
              <div class="row title">
                <div class="item left">费用类型</div>
                <div class="item">D+1费率</div>
              </div>
              <div class="row">
                <div class="item left">微信</div>
                <div class="item">
                  <el-input disabled v-model="scanExtraCommission.wxExtraCommissionD1" class="LowerDivideCent"><template slot="append">%</template></el-input>
                </div>
              </div>
              <div class="row">
                <div class="item left">支付宝</div>
                <div class="item">
                  <el-input disabled v-model="scanExtraCommission.zfbExtraCommissionD1" class="LowerDivideCent"><template slot="append">%</template></el-input>
                </div>
              </div>
            </div>
            <div class="cutom-table">
              <div class="row title">
                <div class="item left">费用类型</div>
                <div class="item">D+1费率&gt;1000元</div>
                <div class="item">D+封顶手续费</div>
                <div class="item">D+1费率≤1000元</div>
              </div>
              <div class="row">
                <div class="item left">借记卡</div>
                <div class="item">
                  <el-input disabled v-model="scanExtraCommission.unionGt1000DebitExtraCommissionD1" class="LowerDivideCent"></el-input>
                </div>
                <div class="item">
                  <el-input disabled v-model="scanExtraCommission.unionDebitExtraTopAmountD1" class="LowerDivideCent"></el-input>
                </div>
                <div class="item">
                  <el-input disabled v-model="scanExtraCommission.unionLt1000DebitExtraCommissionD1" class="LowerDivideCent"><template slot="append">%</template></el-input>
                </div>
              </div>
              <div class="row">
                <div class="item left">贷记卡</div>
                <div class="item">
                  <el-input disabled v-model="scanExtraCommission.unionGt1000CreditExtraCommissionD1" class="LowerDivideCent"></el-input>
                </div>
                <div class="item">
                </div>
                <div class="item">
                  <el-input disabled v-model="scanExtraCommission.unionLt1000CreditExtraCommissionD1" class="LowerDivideCent" @change="subLowerDivideCent"><template slot="append">%</template></el-input>
                </div>
              </div>
            </div>
          </div>
        </el-card>

        <el-card shadow="never">
          <p class="title" v-if="!isAdd && !isAddShop">额度信息</p>
          <el-table :data="cardLimitTable" border size="small" align="center" style="width:720px;" v-if="!isAdd && !isAddShop">
            <el-table-column label="目前刷卡支付T1额度(元)" align="center">
              <el-table-column prop="type" label="类型" align="center"></el-table-column>
              <el-table-column prop="cardDay" label="单卡日额度" width="180" align="center">
                <template slot-scope="scope">
                  <span>{{ limitForm[scope.row.cardDay] }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="cardOnce" label="单笔额度" width="180" align="center">
                <template slot-scope="scope">
                  <span>{{ limitForm[scope.row.cardOnce] }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="cardMonth" label="月总额度" width="180" align="center">
                <template slot-scope="scope">
                  <span>{{ limitForm[scope.row.cardMonth] }}</span>
                </template>
              </el-table-column>
            </el-table-column>
          </el-table>
        </el-card>
        <el-card shadow="never">
          <el-table :data="scanLimitTable" border size="small" style="width: 720px;margin-top: 20px" v-if="!isAdd && !isAddShop">
            <el-table-column label="目前扫码支付总额度(元)" align="center">
              <el-table-column prop="type" label="类型" align="center"></el-table-column>
              <el-table-column prop="scanDay" label="单日限额" width="180" align="center">
                <template slot-scope="scope">
                  <span>{{ limitForm[scope.row.scanDay] }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="scanOnce" label="单笔额度" width="180" align="center">
                <template slot-scope="scope">
                  <span>{{ limitForm[scope.row.scanOnce] }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="scanMonth" label="月总额度" width="180" align="center">
                <template slot-scope="scope">
                  <span>{{ limitForm[scope.row.scanMonth] }}</span>
                </template>
              </el-table-column>
            </el-table-column>
          </el-table>
        </el-card>
      </div>
      <div class="submitBtn" v-if="!readOnly">
        <el-button @click="cancelSubmit" v-if="showCancel">取消</el-button>
        <el-button type="primary" :loading="submitLoading" @click="submit">提交审核</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import qs from 'qs'
import { getMcFee, getMACost } from '@/api/setting'
import { getMerchantInfo, setCommission } from '@/api/merchant'
import { getTemplate, getTemplateList } from '@/api/partner'
const topRateNum = 50 // 代理商成本、商户费率默认封顶值
const topFeeNum = 500 // 代理商成本、商户手续费默认封顶值
export default {
  name: 'RateForm',
  props: {
    // 商户id，不管是编辑还是新增都会有
    id: {
      type: String,
      default: ''
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    isAdd: {
      type: Boolean,
      default: false
    },
    // 是否显示取消按钮
    showCancel: {
      type: Boolean,
      default: false
    },
    // 是否是新增门店的费率
    isAddShop: {
      type: Boolean,
      default: false
    },
    // 总店id，新增门店时需要
    fatherId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isShowD0: false,
      cardTable: [
        {
          type: '借记卡',
          d1: 't1DebitRate',
          d1Max: 't1DebitMaxCharge',
          d0: 't0DebitRate',
          d0Fixed: 't0FixedCharge'
        },
        {
          type: '贷记卡',
          d1: 't1CreditRate',
          d1Max: '--',
          d0: 't0CreditRate',
          d0Fixed: '--'
        },
        {
          type: '境外卡',
          d1: 't1OverseasRate',
          d1Max: '--',
          d0: 't0OverseasRate',
          d0Fixed: '--'
        }
      ],
      scanWechatTable: [
        {
          extraType: '线下（默认）',
          d1: 'weixinT1Rate',
          d0: 'weixinT0Rate'
        }
      ],
      showWechat: [],
      showRihua: [],
      scanWechatMulti: [
        {
          extraTypeL: '绿洲',
          d1L: 'oasis',
          typeLetterL: 'wechat',
          extraTypeR: '公益',
          d1R: 'publicWeal',
          typeLetterR: 'wechat'
        },
        {
          extraTypeL: '高校食堂',
          d1L: 'collegeCanteen',
          typeLetterL: 'wechat',
          extraTypeR: '公缴',
          d1R: 'publicPayment',
          typeLetterR: 'wechat'
        },
        {
          extraTypeL: '私立中小幼',
          d1L: 'privateSchool',
          typeLetterL: 'wechat',
          extraTypeR: '保险',
          d1R: 'insurance',
          typeLetterR: 'wechat'
        },
        {
          extraTypeL: '线上',
          d1L: 'online',
          typeLetterL: 'wechat',
          extraTypeR: '——',
          d1R: '--',
          typeLetterR: 'wechat'
        }
      ],
      scanAlipayTable: [
        {
          d1: 'alipayT1Rate',
          d0: 'alipayT0Rate',
          extraType: '线下（默认）'
        }
      ],
      showAlipay: [],
      scanAlipayMulti: [
        {
          extraTypeL: '线上',
          d1L: 'online',
          typeLetterL: 'alipay',
          extraTypeR: '蓝海活动',
          d1R: 'bluesea',
          typeLetterR: 'alipay'
        },
        {
          extraTypeL: '行业活动0',
          d1L: 'activityFee0',
          typeLetterL: 'alipay',
          extraTypeR: '行业活动1',
          d1R: 'activityFee1',
          typeLetterR: 'alipay'
        }
      ],
      unionpayTable: [
        {
          type: '借记卡',
          d1: 't1UnionpayDebitRate',
          d1Max: 't1UnionpayDebitMaxCharge',
          d1Level2: 't1UnionpayDebitRateLevel2',
          d0: 'fT0UnionDebitRate',
          d0Level2: 'fT0UnionDebitRateLevel2'
        },
        {
          type: '贷记卡',
          d1: 't1UnionpayCreditRate',
          d1Max: '--',
          d1Level2: 't1UnionpayCreditRateLevel2',
          d0: 'fT0UnionCreditRate',
          d0Level2: 'fT0UnionCreditRateLevel2'
        }
      ],
      cardLimitTable: [
        {
          type: '借记卡',
          cardDay: 'debitEachCardDailyLimit',
          cardOnce: 'debitOnceLimit',
          cardMonth: 'debitMonthlyLimit'
        },
        {
          type: '信用卡',
          cardDay: 'creditEachCardDailyLimit',
          cardOnce: 'creditOnceLimit',
          cardMonth: 'creditMonthlyLimit'
        }
      ],
      scanLimitTable: [
        {
          type: '微信',
          scanDay: 'wxDailyLimit',
          scanOnce: 'wxOnceLimit',
          scanMonth: 'wxMonthlyLimit'
        },
        {
          type: '支付宝',
          scanDay: 'alipayDailyLimit',
          scanOnce: 'alipayOnceLimit',
          scanMonth: 'alipayMonthlyLimit'
        },
        {
          type: '银联D1',
          scanDay: 'userTdcodeDayAmountLimit',
          scanOnce: 'userTdcodeOnceAmountLimit',
          scanMonth: 'userTdcodeMonthAmountLimit'
        }
      ],
      scanExtraCommission: {
        wxExtraCommissionD1: 0,
        zfbExtraCommissionD1: 0,
        unionLt1000DebitExtraCommissionD1: 0,
        unionLt1000CreditExtraCommissionD1: 0,
        unionDebitExtraTopAmountD1: 0,

        unionGt1000DebitExtraCommissionD1: 0,
        unionGt1000CreditExtraCommissionD1: 0
      },
      rateForm: {
        t1DebitRate: '',
        t0DebitRate: '',
        t1CreditRate: '',
        t0CreditRate: '',
        t1OverseasRate: '',
        t0OverseasRate: '',
        t1DebitMaxCharge: '',
        t0FixedCharge: '',
        weixinT1Rate: '',
        alipayT1Rate: '',
        weixinT0Rate: '',
        alipayT0Rate: '',
        t1UnionpayDebitRate: '',
        t1UnionpayCreditRate: '',
        t1UnionpayDebitRateLevel2: '',
        t1UnionpayCreditRateLevel2: '',
        t1UnionpayDebitMaxCharge: '',
        fT0UnionCreditRate: 0,
        fT0UnionDebitRate: 0,
        fT0UnionCreditRateLevel2: 0,
        fT0UnionDebitRateLevel2: 0,
        openTypeString: '1,3,4',
        extraFeeRate: {
          alipay: {
            activityFee0: '', // 活动0
            activityFee1: '', // 活动1
            bluesea: '', // 蓝海
            online: ''// 线上
          },
          wechat: {
            collegeCanteen: '', // 高校食堂
            insurance: '', // 保险
            oasis: '', // 绿洲
            online: '', // 线上
            privateSchool: '', // 私立学校
            publicPayment: '', // 公缴
            publicWeal: ''// 公益
          }
        },
        wxCategoryDebitCommissionD1: '',
        wxCategoryCreditCommissionD1: ''
      },
      // 各费率最低值，即默认费率
      defaultRate: {
        t1DebitRate: 0,
        t0DebitRate: 0,
        t1CreditRate: 0,
        t0CreditRate: 0,
        t1OverseasRate: 0,
        t0OverseasRate: 0,
        t1DebitMaxCharge: 0,
        t0FixedCharge: 0,
        weixinT1Rate: 0,
        alipayT1Rate: 0,
        weixinT0Rate: 0,
        alipayT0Rate: 0,
        t1UnionpayDebitRate: 0,
        t1UnionpayCreditRate: 0,
        t1UnionpayDebitRateLevel2: 0,
        t1UnionpayCreditRateLevel2: 0,
        t1UnionpayDebitMaxCharge: 0,
        fT0UnionCreditRate: 0,
        fT0UnionDebitRate: 0,
        fT0UnionCreditRateLevel2: 0,
        fT0UnionDebitRateLevel2: 0,
        extraFeeRate: {
          alipay: {
            activityFee0: '', // 活动0
            activityFee1: '', // 活动1
            bluesea: '', // 蓝海
            online: ''// 线上
          },
          wechat: {
            collegeCanteen: '', // 高校食堂
            insurance: '', // 保险
            oasis: '', // 绿洲
            online: '', // 线上
            privateSchool: '', // 私立学校
            publicPayment: '', // 公缴
            publicWeal: ''// 公益
          }
        },
        wxCategoryDebitCommissionD1: '',
        wxCategoryCreditCommissionD1: ''
      },
      saleLoading: false,
      rateTemplateList: [], // 费率模板id
      selectedTemplate: -1, // 选中的费率id
      defaultTemplateId: -1, // 默认选中费率id
      submitLoading: false, // 提交加载
      limitForm: {
        debitEachCardDailyLimit: '', // 借记卡单日限额
        debitOnceLimit: '', // 借记卡单笔限额
        debitMonthlyLimit: '', // 借记卡月总限额
        creditEachCardDailyLimit: '', // 信用卡单日限额
        creditOnceLimit: '',
        creditMonthlyLimit: '',
        wxDailyLimit: '', // 微信扫码额度
        wxOnceLimit: '',
        wxMonthlyLimit: '',
        alipayDailyLimit: '', // 支付宝扫码额度
        alipayOnceLimit: '',
        alipayMonthlyLimit: '',
        userTdcodeDayAmountLimit: '', // 银联D1扫码
        userTdcodeOnceAmountLimit: '',
        userTdcodeMonthAmountLimit: ''
      }// 额度表单数据
    }
  },
  beforeMount () {
    this.getTemplateList()
  },
  mounted () {
    this.getInfoRate()
  },
  watch: {
    id (val) {
      this.getInfoRate()
    }
  },
  methods: {
    /**
             * 获取初始数据
             */
    async getInfoRate () {
      this.saleLoading = true
      if (this.isEdit || this.readOnly || this.isAddShop) {
        await this.getInitRate()// 获取初始费率
        this.selectedTemplate = ''
      } else {
        await this.getTemplateList()
        if (this.selectedTemplate >= 0) {
          this.getTemplate(this.selectedTemplate)
        } else {
          await this.setTemplateRate()
        }
      }
      await this.getDefaultRate()// 获取默认费率
      await this.getT0DefaultRate()// 活动d0代理商默认费率
      this.saleLoading = false
      this.showAlipay = []
      this.showWechat = []
    },
    // 活动d0代理商默认费率
    getT0DefaultRate () {
      const that = this
      return new Promise((resolve, reject) => {
        getMACost({ merchantId: this.id }).then(response => {
          if (response.error_code !== '0') {
            resolve(false)
          } else {
            resolve()
            const scan = response.data
            that.defaultRate.weixinT0Rate = (scan.t0WechatScan) / 100
            that.defaultRate.alipayT0Rate = (scan.t0AlipayScan) / 100
            that.defaultRate.fT0UnionDebitRate = (scan.t0UnionScanDebitGt1000) / 100
            that.defaultRate.fT0UnionCreditRate = (scan.t0UnionScanCreditGt1000) / 100
            that.defaultRate.fT0UnionDebitRateLevel2 = scan.t0UnionScanDebitLt1000 / 100
            that.defaultRate.fT0UnionCreditRateLevel2 = scan.t0UnionScanCreditLt1000 / 100
          }
        }).catch(() => {
          var that = this
          that.$message({
            showClose: true,
            message: '获取不到当前商户费率，请稍后重试',
            type: 'error'
          })
        })
      })
    },
    /**
             * 获取默认费率
             */
    getDefaultRate () {
      const that = this
      let data = {}
      data = qs.stringify(data)
      return new Promise((resolve, reject) => {
        getMcFee(data).then(response => {
          if (response.error_code !== '0') {
            resolve(false)
          } else {
            resolve()
            const pos = response.minCommission.pos
            const scan = response.minCommission.scan
            const unionpay = response.minCommission.unionpay

            // 以下数据作为默认费率，设置不可低于默认费率
            that.defaultRate.t1DebitRate = (pos.t1DebitCommission) / 100
            that.defaultRate.t0DebitRate = (pos.t0DebitCommission) / 100
            that.defaultRate.t1CreditRate = (pos.t1CreditCommission) / 100
            that.defaultRate.t0CreditRate = (pos.t0CreditCommission) / 100
            that.defaultRate.t1OverseasRate = (pos.t1OverSeasCommission) / 100
            that.defaultRate.t0OverseasRate = (pos.t0OverSeasCommission) / 100
            that.defaultRate.t1DebitMaxCharge = (pos.t1DebitMaxFee) / 1000000
            that.defaultRate.t0FixedCharge = (pos.t0FixFee) / 1000000
            that.defaultRate.weixinT1Rate = (scan.t1WeixinCommission) / 100
            that.defaultRate.alipayT1Rate = (scan.t1AlipayCommission) / 100
            that.defaultRate.weixinT0Rate = (scan.t0WeixinCommission) / 100
            that.defaultRate.alipayT0Rate = (scan.t0AlipayCommission) / 100
            that.defaultRate.t1UnionpayDebitRate = (unionpay.fT1DebitCommissionBymillion) / 100
            that.defaultRate.t1UnionpayCreditRate = (unionpay.fT1CreditCommissionBymillion) / 100
            that.defaultRate.t1UnionpayDebitRateLevel2 = unionpay.fT1DebitCommissionBymillionLevel2 / 100
            that.defaultRate.t1UnionpayCreditRateLevel2 = unionpay.fT1CreditCommissionBymillionLevel2 / 100
            that.defaultRate.t1UnionpayDebitMaxCharge = (unionpay.fT1DebitMaxFeeBymillion) / 1000000
            that.defaultRate.fT0UnionDebitRate = (unionpay.fT0DebitCommissionBymillion) / 100
            that.defaultRate.fT0UnionCreditRate = (unionpay.fT0CreditCommissionBymillion) / 100
            that.defaultRate.fT0UnionDebitRateLevel2 = unionpay.fT0DebitCommissionBymillionLevel2 / 100
            that.defaultRate.fT0UnionCreditRateLevel2 = unionpay.fT0CreditCommissionBymillionLevel2 / 100

            that.defaultRate.wxCategoryDebitCommissionD1 = (scan.wxCategoryDebitCommissionD1) / 100
            that.defaultRate.wxCategoryCreditCommissionD1 = (scan.wxCategoryCreditCommissionD1) / 100

            if (scan.extraFeeRate) {
              const extraFeeRate = JSON.parse(scan.extraFeeRate)
              for (const item in that.defaultRate.extraFeeRate.alipay) {
                if (typeof (extraFeeRate.alipay[item]) === 'number') {
                  that.defaultRate.extraFeeRate.alipay[item] = (extraFeeRate.alipay[item]) / 100
                } else {
                  that.defaultRate.extraFeeRate.alipay[item] = ''
                }
              }
              for (const item in that.defaultRate.extraFeeRate.wechat) {
                if (typeof (extraFeeRate.wechat[item]) === 'number') {
                  that.defaultRate.extraFeeRate.wechat[item] = (extraFeeRate.wechat[item]) / 100
                } else {
                  that.defaultRate.extraFeeRate.wechat[item] = ''
                }
              }
            }
            console.log(that.defaultRate.extraFeeRate)
          }
        }).catch(() => {
          var that = this
          that.$message({
            showClose: true,
            message: '获取不到当前商户费率，请稍后重试',
            type: 'error'
          })
        })
      })
    },
    /**
             * 获取初始费率
             */
    getInitRate () {
      const that = this
      let data = {
        merchantId: this.id
      }
      if (this.isAddShop) {
        data.merchantId = this.fatherId
      }
      data = qs.stringify(data)
      return new Promise((resolve, reject) => {
        getMerchantInfo(data).then(response => {
          if (response.result_cde !== '0') {
            resolve(false)
          } else {
            resolve()
            this.isShowD0 = response.basic.t0Settle === 1
            const pos = response.posCommission
            const scan = response.scanCommission
            const unionpay = response.uionpayScanInfo
            if (pos) {
              that.rateForm.t1DebitRate = (pos.fT1DebitCardCommission) / 100 || ''
              that.rateForm.t0DebitRate = (pos.fT0DebitCardCommission) / 100 || ''
              that.rateForm.t1CreditRate = (pos.fT1CreditCardCommission) / 100 || ''
              that.rateForm.t0CreditRate = (pos.fT0CreditCardCommission) / 100 || ''
              that.rateForm.t1OverseasRate = (pos.fT1OverseasCardCommission) / 100 || ''
              that.rateForm.t0OverseasRate = (pos.fT0OverseasCardCommission) / 100 || ''
              that.rateForm.t1DebitMaxCharge = (pos.fT1DebitCardMaxFee) / 1000000 || ''
              that.rateForm.t0FixedCharge = (pos.fT0CommissionFixed) / 1000000 || ''
            }
            if (scan) {
              that.rateForm.weixinT1Rate = (scan.weixinT1Rate) / 100 || ''
              that.rateForm.weixinT0Rate = (scan.weixinT0Rate) / 100 || ''
              that.rateForm.alipayT1Rate = (scan.alipayT1Rate) / 100 || ''
              that.rateForm.alipayT0Rate = (scan.alipayT0Rate) / 100 || ''
              if (scan.extraFeeRate) {
                const extraFeeRate = JSON.parse(scan.extraFeeRate)
                console.log(extraFeeRate)
                for (const item in that.rateForm.extraFeeRate.alipay) {
                  if (typeof (extraFeeRate.alipay[item]) === 'number') {
                    that.rateForm.extraFeeRate.alipay[item] = (extraFeeRate.alipay[item]) / 100
                  } else {
                    that.rateForm.extraFeeRate.alipay[item] = ''
                  }
                }
                for (const item in that.rateForm.extraFeeRate.wechat) {
                  if (typeof (extraFeeRate.wechat[item]) === 'number') {
                    that.rateForm.extraFeeRate.wechat[item] = (extraFeeRate.wechat[item]) / 100
                  } else {
                    that.rateForm.extraFeeRate.wechat[item] = ''
                  }
                }
              }
              // 新增日化
              that.rateForm.wxCategoryDebitCommissionD1 = scan.wxCategoryDebitCommissionD1 / 100 || ''
              that.rateForm.wxCategoryCreditCommissionD1 = scan.wxCategoryCreditCommissionD1 / 100 || ''
            }
            if (unionpay) {
              that.rateForm.fT0UnionDebitRate = (unionpay.fT0UnionDebitRate) / 100 || 0
              that.rateForm.fT0UnionCreditRate = (unionpay.fT0UnionCreditRate) / 100 || 0
              that.rateForm.fT0UnionDebitRateLevel2 = unionpay.fT0UnionDebitRateLevel2 / 100 || 0
              that.rateForm.fT0UnionCreditRateLevel2 = unionpay.fT0UnionCreditRateLevel2 / 100 || 0
              that.rateForm.t1UnionpayDebitRate = (unionpay.fT1UnionDebitRate) / 100 || 0
              that.rateForm.t1UnionpayCreditRate = (unionpay.fT1UnionCreditRate) / 100 || 0
              that.rateForm.t1UnionpayDebitRateLevel2 = unionpay.fT1UnionDebitRateLevel2 / 100 || 0
              that.rateForm.t1UnionpayCreditRateLevel2 = unionpay.fT1UnionCreditRateLevel2 / 100 || 0
              that.rateForm.t1UnionpayDebitMaxCharge = (unionpay.fT1UnionDebitCardMaxRate) / 1000000 || 0
            }
            // 新增门店没有费率
            if (response.quotaDetail) {
              // 额度赋值
              const limit = response.quotaDetail
              if (limit.pos) {
                that.limitForm.creditMonthlyLimit = (limit.pos.icCreditEachCardMonthlyLimit + limit.pos.magneticCreditEachCardMonthlyLimit) / 100 || '0'
                that.limitForm.creditOnceLimit = (limit.pos.icCreditOnceLimit + limit.pos.magneticCreditOnceLimit) / 100 || '0'
                that.limitForm.creditEachCardDailyLimit = (limit.pos.icCreditEachCardDailyLimit + limit.pos.magneticCreditEachCardDailyLimit) / 100 || '0'
                that.limitForm.debitMonthlyLimit = (limit.pos.icDebitEachCardMonthlyLimit + limit.pos.magneticDebitEachCardMonthlyLimit) / 100 || '0'
                that.limitForm.debitOnceLimit = (limit.pos.icDebitOnceLimit + limit.pos.magneticDebitOnceLimit) / 100 || '0'
                that.limitForm.debitEachCardDailyLimit = (limit.pos.icDebitEachCardDailyLimit + limit.pos.magneticDebitEachCardDailyLimit) / 100 || '0'
              }
              if (limit.wxAlipayScan) {
                that.limitForm.wxMonthlyLimit = (limit.wxAlipayScan.wxMonthlyLimit) / 100 || '0'
                that.limitForm.wxOnceLimit = (limit.wxAlipayScan.wxOnceLimit) / 100 || '0'
                that.limitForm.wxDailyLimit = (limit.wxAlipayScan.wxDailyLimit) / 100 || '0'
                that.limitForm.alipayMonthlyLimit = (limit.wxAlipayScan.alipayMonthlyLimit) / 100 || '0'
                that.limitForm.alipayOnceLimit = (limit.wxAlipayScan.alipayOnceLimit) / 100 || '0'
                that.limitForm.alipayDailyLimit = (limit.wxAlipayScan.alipayDailyLimit) / 100 || '0'
              }
              if (limit.unionScan) {
                that.limitForm.userTdcodeMonthAmountLimit = (limit.unionScan.userTdcodeMonthAmountLimit) / 100 || '0'
                that.limitForm.userTdcodeOnceAmountLimit = (limit.unionScan.userTdcodeOnceAmountLimit) / 100 || '0'
                that.limitForm.userTdcodeDayAmountLimit = (limit.unionScan.userTdcodeDayAmountLimit) / 100 || '0'
              }
            }

            // 新增扫码点餐费率
            if (response.scanExtraCommission) {
              // response.scanExtraCommission.wxExtraCommissionD1 = response.scanExtraCommission.wxExtraCommissionD1 / 100
              // response.scanExtraCommission.zfbExtraCommissionD1 = response.scanExtraCommission.zfbExtraCommissionD1 / 100
              // response.scanExtraCommission.unionLt1000DebitExtraCommissionD1 = response.scanExtraCommission.unionLt1000DebitExtraCommissionD1 / 100
              // response.scanExtraCommission.unionLt1000CreditExtraCommissionD1 = response.scanExtraCommission.unionLt1000CreditExtraCommissionD1 / 100
              // response.scanExtraCommission.unionDebitExtraTopAmountD1 = response.scanExtraCommission.unionDebitExtraTopAmountD1 / 100

              // response.scanExtraCommission.unionGt1000DebitExtraCommissionD1 = response.scanExtraCommission.unionGt1000DebitExtraCommissionD1 / 100
              // response.scanExtraCommission.unionGt1000CreditExtraCommissionD1 = response.scanExtraCommission.unionGt1000CreditExtraCommissionD1 / 100

              response.scanExtraCommission.wxExtraCommissionD1 = 0
              response.scanExtraCommission.zfbExtraCommissionD1 = 0
              response.scanExtraCommission.unionLt1000DebitExtraCommissionD1 = 0
              response.scanExtraCommission.unionLt1000CreditExtraCommissionD1 = 0
              response.scanExtraCommission.unionDebitExtraTopAmountD1 = 0

              response.scanExtraCommission.unionGt1000DebitExtraCommissionD1 = 0
              response.scanExtraCommission.unionGt1000CreditExtraCommissionD1 = 0

              that.scanExtraCommission = response.scanExtraCommission
            }
          }
        }).catch(() => {
          var that = this
          that.$message({
            showClose: true,
            message: '获取不到当前商户费率，请稍后重试',
            type: 'error'
          })
        })
      }).catch(function () {

      })
    },
    /**
             * 获取模板下拉列表
             */
    getTemplateList () {
      const params = qs.stringify({
        type: 2
      })
      return new Promise((resolve, reject) => {
        getTemplateList(params).then(response => {
          if (response.error_code === '0') {
            resolve()
            this.rateTemplateList = response.data
            if (response.defaultId && !this.isEdit) {
              this.selectedTemplate = response.defaultId
              this.defaultTemplateId = response.defaultId
            } else {
              // 默认不能选中某一费率模板，因为默认是总店的费率
              this.selectedTemplate = -1
              this.defaultTemplateId = -1
            }
          } else {
            this.$message({
              message: response.error_msg,
              type: 'error'
            })
          }
        }).catch(() => {
          this.$message({
            showClose: true,
            message: '获取费率模板失败，请重试！',
            type: 'error'
          })
        })
      })
    },
    /**
             * 费率模板选择change
             */
    rateTemplateSelectChange (templateId) {
      if (templateId >= 0) {
        this.getTemplate(templateId)
      } else {
        this.setTemplateRate()
      }
    },
    /**
             * 根据id获取模板信息
             */
    getTemplate (id) {
      const params = qs.stringify({
        id: id
      })
      getTemplate(params).then(response => {
        console.log('getTemplate response:', response)
        if (response.error_code === '0') {
          this.setTemplateRate({
            fRate: response.fRate,
            ...response.data
          })
        } else {
          this.$message({
            message: response.error_msg,
            type: 'error'
          })
        }
      })
    },
    /**
             * 展示费率模板
             */
    setTemplateRate (rateInfo) {
      const that = this
      console.log(rateInfo)
      if (rateInfo) {
        that.rateForm.t1DebitRate = (rateInfo.fT1DebitRate) / 10000
        that.rateForm.t0DebitRate = (rateInfo.fT0DebitRate) / 10000
        that.rateForm.t1CreditRate = (rateInfo.fT1CreditRate) / 10000
        that.rateForm.t0CreditRate = (rateInfo.fT0CreditRate) / 10000
        that.rateForm.t1OverseasRate = (rateInfo.fT1OverSeasRate) / 10000
        that.rateForm.t0OverseasRate = (rateInfo.fT0OverSeasRate) / 10000
        that.rateForm.t1DebitMaxCharge = (rateInfo.fT1DebitFeeMax) / 1000000
        that.rateForm.t0FixedCharge = (rateInfo.fT0FixedFee) / 1000000
        that.rateForm.weixinT1Rate = (rateInfo.fWxT1Rate) / 10000
        that.rateForm.alipayT1Rate = (rateInfo.fAliT1Rate) / 10000
        that.rateForm.fT0UnionDebitRate = (rateInfo.fT0UnionpayDebitRate) / 10000
        that.rateForm.fT0UnionCreditRate = (rateInfo.fT0UnionpayCreditRate) / 10000
        that.rateForm.fT0UnionDebitRateLevel2 = rateInfo.fT0UnionpayDebitRateLv2 / 10000
        that.rateForm.fT0UnionCreditRateLevel2 = rateInfo.fT0UnionpayCreditRateLv2 / 10000
        that.rateForm.t1UnionpayDebitRate = (rateInfo.fT1UnionpayDebitRate) / 10000
        that.rateForm.t1UnionpayCreditRate = (rateInfo.fT1UnionpayCreditRate) / 10000
        that.rateForm.t1UnionpayDebitRateLevel2 = rateInfo.fT1UnionpayDebitRateLv2 / 10000
        that.rateForm.t1UnionpayCreditRateLevel2 = rateInfo.fT1UnionpayCreditRateLv2 / 10000
        that.rateForm.t1UnionpayDebitMaxCharge = rateInfo.fT1UnionpayDebitMaxCharge / 1000000
        if (rateInfo.fExtraData) {
          const extraFeeRate = JSON.parse(rateInfo.fExtraData)
          console.log(extraFeeRate)
          for (const item in that.rateForm.extraFeeRate.alipay) {
            if (typeof (extraFeeRate.alipay[item]) === 'number') {
              that.rateForm.extraFeeRate.alipay[item] = (extraFeeRate.alipay[item]) / 10000
            } else {
              that.rateForm.extraFeeRate.alipay[item] = ''
            }
          }
          for (const item in that.rateForm.extraFeeRate.wechat) {
            if (typeof (extraFeeRate.wechat[item]) === 'number') {
              that.rateForm.extraFeeRate.wechat[item] = (extraFeeRate.wechat[item]) / 10000
            } else {
              that.rateForm.extraFeeRate.wechat[item] = ''
            }
          }
        }
        console.log(that.rateForm)
      } else {
        // 如果选择的是自定义，就是恢复默认值
        that.rateForm = that.$options.data().rateForm
      }
    },
    // 费率失去光标
    onRateBlur (value, extraValue) {
      let message = ''
      let numberValue, defaultValue
      if (extraValue) {
        const extraText = extraValue.split('.')
        numberValue = Number(this.rateForm.extraFeeRate[extraText[0]][extraText[1]])// 格式转换
        defaultValue = this.defaultRate.extraFeeRate[extraText[0]][extraText[1]]
        // return true; // 多通道费率先不校验
      } else {
        numberValue = Number(this.rateForm[value])// 格式转换
        defaultValue = this.defaultRate[value]// 默认值
      }
      let result = true// 校验结果
      let type = ''// 校验类型
      // 除多通道费率，如果费率为空或小于默认值，校验不通过
      if ((!extraValue && !numberValue) || numberValue < defaultValue) {
        result = false
      }
      if (extraValue && ((!numberValue && defaultValue >= 0) || numberValue < defaultValue)) {
        result = false
      }
      // 判断类型，根据不同类型进行不同校验
      if (value.toLowerCase().indexOf('t1') >= 0) {
        type = 'T1'
      }
      if (value.toLowerCase().indexOf('t1') >= 0 && value.toLowerCase().indexOf('overseas') >= 0) {
        type = 'T1Overseas'
      }
      if (value.toLowerCase().indexOf('t0') >= 0 && value.toLowerCase().indexOf('weixinT0Rate') === 0 && value.toLowerCase().indexOf('alipayT0Rate') === 0) {
        type = 'T0'
      }
      if (value.toLowerCase().indexOf('weixint0rate') >= 0 || value.toLowerCase().indexOf('alipayt0rate') >= 0 || value.toLowerCase().indexOf('ft0union') >= 0) {
        type = 'D0'
      }
      if (value.toLowerCase().indexOf('unionpay') >= 0) {
        type = 'UnionRate'
      }
      if (value.toLowerCase().indexOf('t1') >= 0 && value.toLowerCase().indexOf('charge') >= 0) {
        type = 'T1Fee'
      }
      if (value.toLowerCase().indexOf('t0') >= 0 && value.toLowerCase().indexOf('charge') >= 0) {
        type = 'T0Fee'
      }
      // 不同类型的报错信息不一致
      switch (type) {
        case 'T1': {
          message = `D1费率不能为空 或 大于${topRateNum}% 或小于默认费率`
          if (numberValue > topRateNum) {
            result = false
          }
          break
        }
        case 'T1Overseas': {
          message = `D1费率不能为空 或 大于${topRateNum}% 或小于默认费率`
          if (numberValue > topRateNum) {
            result = false
          }
          break
        }
        case 'T0': {
          message = `D0费率不能为空 或 大于${topRateNum}% 或小于默认费率`
          if (numberValue > topRateNum) {
            result = false
          }
          break
        }
        case 'D0': {
          message = 'D0费率不能为空 或 大于0.6 或小于默认费率'
          result = true
          if (numberValue > 60) {
            result = false
          }
          break
        }
        case 'T0Fee': {
          message = '单笔手续费不能为空、小于默认手续费 或超过20'
          if (numberValue > topFeeNum) {
            result = false
          }
          break
        }
        case 'T1Fee': {
          message = `手续费不能为空、小于默认手续费 或 超过${topFeeNum}元`
          if (numberValue > topFeeNum) {
            result = false
          }
          break
        }
        case 'UnionRate': {
          message = 'D+0费不能为空、小于默认手续费 或 大于0.6'
          result = true
          break
        }
        default: {
          message = `当前费率不能为空 或 大于${topRateNum}% 或小于默认费率`
          if (numberValue > topRateNum) {
            result = false
          }
        }
      }

      if (!result) {
        this.$message({
          showClose: true,
          message: message,
          type: 'warning'
        })
        if (extraValue) {
          const extraText = extraValue.split('.')
          this.rateForm.extraFeeRate[extraText[0]][extraText[1]] = defaultValue
          console.log(this.rateForm.extraFeeRate[extraText[0]][extraText[1]])
        } else {
          this.rateForm[value] = defaultValue
        }
        return false
      }
      return true
    },
    async submit () {
      const that = this
      let rate = {
        t1DebitRate: Math.round(parseFloat(that.rateForm.t1DebitRate).toFixed(2) * 100),
        t0DebitRate: Math.round(parseFloat(that.rateForm.t0DebitRate) * 100),
        t1CreditRate: Math.round(parseFloat(that.rateForm.t1CreditRate) * 100),
        t0CreditRate: Math.round(parseFloat(that.rateForm.t0CreditRate) * 100),
        t1OverseasRate: Math.round(parseFloat(that.rateForm.t1OverseasRate) * 100),
        t0OverseasRate: Math.round(parseFloat(that.rateForm.t0OverseasRate) * 100),
        t1DebitMaxCharge: Math.round(parseFloat(that.rateForm.t1DebitMaxCharge) * 1000000),
        t0FixedCharge: Math.round(parseFloat(that.rateForm.t0FixedCharge) * 1000000),
        weixinT1Rate: Math.round(parseFloat(that.rateForm.weixinT1Rate) * 100),
        alipayT1Rate: Math.round(parseFloat(that.rateForm.alipayT1Rate) * 100),
        weixinT0Rate: Math.round(parseFloat(that.rateForm.weixinT0Rate) * 100),
        alipayT0Rate: Math.round(parseFloat(that.rateForm.alipayT0Rate) * 100),
        t1UnionpayDebitRate: Math.round(parseFloat(that.rateForm.t1UnionpayDebitRate) * 100),
        t1UnionpayCreditRate: Math.round(parseFloat(that.rateForm.t1UnionpayCreditRate) * 100),
        t1UnionpayDebitRateLevel2: Math.round(parseFloat(that.rateForm.t1UnionpayDebitRateLevel2) * 100),
        t1UnionpayCreditRateLevel2: Math.round(parseFloat(that.rateForm.t1UnionpayCreditRateLevel2) * 100),
        t0UnionpayDebitRate: Math.round(parseFloat(that.rateForm.fT0UnionDebitRate) * 100),
        t0UnionpayCreditRate: Math.round(parseFloat(that.rateForm.fT0UnionCreditRate) * 100),
        t0UnionpayDebitRateLevel2: Math.round(parseFloat(that.rateForm.fT0UnionDebitRateLevel2) * 100),
        t0UnionpayCreditRateLevel2: Math.round(parseFloat(that.rateForm.fT0UnionCreditRateLevel2) * 100),
        t1UnionpayDebitMaxCharge: Math.round(parseFloat(that.rateForm.t1UnionpayDebitMaxCharge) * 1000000),
        wxCategoryDebitCommissionD1: Math.round(parseFloat(that.rateForm.wxCategoryDebitCommissionD1) * 100),
        wxCategoryCreditCommissionD1: Math.round(parseFloat(that.rateForm.wxCategoryCreditCommissionD1) * 100)
      }
      Object.keys(rate).forEach(item => {
        if (this.isEmpty(rate[item])) {
          delete rate[item]
        }
        // if (item === 'weixinT0Rate' || item === 'alipayT0Rate') {
        //   if (isNaN(rate[item])) {
        //     delete rate[item]
        //   }
        // }
        // 如果为NaN的话，删除改字段，不传到后端
        if (isNaN(rate[item])) {
          delete rate[item]
        }
      })
      console.log('🚀 ~ file: rateForm.vue ~ line 1270 ~ submit ~ rate', rate)

      // 检查每个费率是否正确
      // for (const key in rate) {
      //   if (!this.onRateBlur(key)) {
      //     console.log(key)
      //     return
      //   }
      // }
      const extraFeeRate = {
        alipay: {},
        wechat: {}
      }
      for (const element in this.rateForm.extraFeeRate.alipay) {
        extraFeeRate.alipay[element] = this.rateForm.extraFeeRate.alipay[element] !== '' ? Math.round(parseFloat(this.rateForm.extraFeeRate.alipay[element]) * 100) : ''
      }
      for (const element in this.rateForm.extraFeeRate.wechat) {
        extraFeeRate.wechat[element] = this.rateForm.extraFeeRate.wechat[element] !== '' ? Math.round(parseFloat(this.rateForm.extraFeeRate.wechat[element]) * 100) : ''
      }
      rate = Object.assign(rate, {
        merchantId: that.id,
        openTypeString: '1,3,4',
        extraFeeRate: JSON.stringify(extraFeeRate)
      })
      // 新增扫码点单费率字段
      rate.wxExtraCommissionD1 = Math.round(this.scanExtraCommission.wxExtraCommissionD1 * 100)
      rate.zfbExtraCommissionD1 = Math.round(this.scanExtraCommission.zfbExtraCommissionD1 * 100)
      rate.unionLt1000DebitExtraCommissionD1 = Math.round(this.scanExtraCommission.unionLt1000DebitExtraCommissionD1 * 100)
      rate.unionLt1000CreditExtraCommissionD1 = Math.round(this.scanExtraCommission.unionLt1000CreditExtraCommissionD1 * 100)
      rate.unionDebitExtraTopAmountD1 = Math.round(this.scanExtraCommission.unionDebitExtraTopAmountD1 * 100)

      rate.unionGt1000DebitExtraCommissionD1 = Math.round(this.scanExtraCommission.unionGt1000DebitExtraCommissionD1 * 100)
      rate.unionGt1000CreditExtraCommissionD1 = Math.round(this.scanExtraCommission.unionGt1000CreditExtraCommissionD1 * 100)

      const duringLimit = await this.limitRate()
      if (!duringLimit) { return }
      that.$confirm('是否确认提交', '提示', {}).then(() => {
        // let data = Object.assign(rate,that.otherRate);
        let data = rate
        data = qs.stringify(data)
        that.submitLoading = true
        setCommission(data).then(response => {
          that.submitLoading = false
          if (response.error_code !== '0') {
            that.$message({
              showClose: true,
              message: response.error_msg,
              type: 'error'
            })
            that.$emit('submit', false)
          } else {
            that.$message({
              message: response.error_msg,
              type: 'success'
            })
            that.$emit('submit', true)
          }
        }).catch(() => {
          that.$message({
            showClose: true,
            message: '请求失败，请检查网络重试',
            type: 'error'
          })
        })
      })
    },
    // 判空
    isEmpty (val) {
      if (typeof val === 'undefined' || val === null || val === '') {
        return true
      } else {
        return false
      }
    },
    // 取消提交表单
    cancelSubmit () {
      this.$emit('cancel', '')
    },
    /**
             * 费率过高提醒
             */
    async limitRate () {
      return new Promise((resolve, reject) => {
        let result = true
        const that = this
        for (const i in this.rateForm) {
          if (i.indexOf('t1') >= 0 && i.indexOf('Overseas') < 0 && i.indexOf('Charge') < 0 && result && that.rateForm[i] > 0.39 && that.rateForm[i] < 0.99) {
            result = false
            break
          }
        }
        if (!result) {
          this.$confirm('您设置的商户费率较高，为避免填写错误，请再次检查', '温馨提醒', {
            cancelButtonText: '已检查过',
            confirmButtonText: '好的'
          }).then(() => {
            resolve(false)
          }).catch(() => {
            resolve(true)
          })
        } else {
          resolve(true)
        }
      })
    },
    editTemplateTableSpanMethod ({ row, column, rowIndex, columnIndex }) {
      if (column.label === 'D+0单笔手续费') {
        if (rowIndex === 0) {
          return {
            rowspan: 3,
            colspan: 1
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0
          }
        }
      }
    },
    clickExtraRate (type, key) {
      if (this.defaultRate.extraFeeRate[type][key] === '' && !this.readOnly) {
        this.$message({
          showClose: true,
          message: '代理商未开通此通道交易，无法设置费率',
          type: 'warning'
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.two-table {
  display: flex;
  .cutom-table {
    margin-right: 60px;
    .row {
      display: flex;
      align-items: center;
      &.title {
        background: #F5F7FA;
      }
      .item {
        padding: 10px;
        width: 200px;
        &.left {
          width: 150px;
        }
      }
    }
  }
}
.row {
  display: flex;
  .item {
    padding: 8px;
    width: 180px;
    box-sizing: content-box;
    text-align:center;
    border-right: 1px solid #EBEEF5;
    border-bottom: 1px solid #EBEEF5;
    &:first-child {
      border-left: 1px solid #EBEEF5;
    }
  }
}
</style>
<style>
    .rateForm .el-input span{
        line-height: 40px;
        color: #606266;
        font-size: inherit;
    }
    .rateForm .el-input--suffix .el-input__inner {
        padding-right: 30px;
        text-align: center;
    }
    .title{
        font-size: 14px;
        color: #606266;
        line-height: 40px;
    }
    h3{
        margin-top: 25px;
        margin-bottom: 20px;
    }
    .cell .el-input input{
        text-align: center;
    }
    .submitBtn{
        margin: 20px 0;
        text-align: center;
    }
    .rateForm .el-collapse-item__header{
        border-left: 1px solid #EBEEF5;
        border-right: 1px solid #EBEEF5;
        padding-left: 20px;
        line-height: 1;
        background: #F5F7FA;
        color: #909399;
    }
    .rateForm .el-collapse-item__wrap{
        border-bottom: none;
    }
</style>
